// extracted by mini-css-extract-plugin
export var bodySections = "_4c-8";
export var gray = "_4c-7";
export var green = "_4c-4";
export var iconContainer = "_4c-9";
export var iconWidgetContainer = "_4c-1";
export var phoneIcon = "_4c-2";
export var red = "_4c-5";
export var statusDot = "_4c-3";
export var widgetContainer = "_4c-0";
export var yellow = "_4c-6";